import React from 'react';
import '../BecomeDriver.css';
import { useNavigate } from 'react-router-dom'; // Add for navigation
const BecomeDriver = () => {
  const navigate = useNavigate(); // Hook to navigate if token expires
    const Buttonclick=(e)=>{
      navigate("/DriveDetail")
    }
  return (
    <section className="become-driver">
      <div className="become-driver-content">
        <img
          src="/Driver1.jpg" // Replace with your driver image URL
          alt="Driver"
          className="become-driver-image"
        />
        <div className="become-driver-text">
          <h2 className="become-driver-heading">Join Our Team as a Driver</h2>
          <p className="become-driver-paragraph">
            Are you passionate about driving and looking for an exciting opportunity in the car transport industry? 
            Join our team at <strong>Zoom Autos</strong>, where you’ll be part of a dedicated and professional 
            team delivering exceptional service across the UK.
          </p>
          <p className="become-driver-paragraph">
            <strong>What We’re Looking For:</strong>
            <ul>
              <li>A valid UK driving license (HGV or standard, depending on the role).</li>
              <li>A strong commitment to safety and professionalism.</li>
              <li>Experience in vehicle transport or logistics is a plus, but not required.</li>
              <li>A positive attitude and excellent customer service skills.</li>
            </ul>
          </p>
          <button className="become-driver-button" onClick={Buttonclick} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 auto' }}>
  Apply Now
</button>

        </div>
      </div>
    </section>
  );
};

export default BecomeDriver;
